import { useEffect } from 'react';

const useSwipe = (ref) => {
  useEffect(() => {
    const container = ref.current;
    if (!container) return;

    let isDown = false;
    let startX, scrollLeft;
    let touchStartX = 0, touchEndX = 0, isTouchOnButton = false;

    // Touch
    container.addEventListener('touchstart', (e) => {
      const target = e.target as HTMLElement;
      isTouchOnButton = target.closest('.buy-button') !== null;
      if (isTouchOnButton) return;
      touchStartX = e.touches[0].clientX;
    });

    container.addEventListener('touchmove', (e) => {
      if (isTouchOnButton) return;
      touchEndX = e.touches[0].clientX;
    });

    container.addEventListener('touchend', () => {
      if (isTouchOnButton) return;
      const distance = touchStartX - touchEndX;
      if (distance > 50) container.scrollBy({ left: 300, behavior: 'smooth' });
      else if (distance < -50) container.scrollBy({ left: -300, behavior: 'smooth' });
    });

    // Mouse
    container.addEventListener('mousedown', (e) => {
      const target = e.target as HTMLElement;
      if (target.closest('.buy-button')) return;
      isDown = true;
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    });

    container.addEventListener('mouseleave', () => (isDown = false));
    container.addEventListener('mouseup', () => (isDown = false));
    container.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      const target = e.target as HTMLElement;
      if (target.closest('.buy-button')) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 1.2;
      container.scrollLeft = scrollLeft - walk;
    });

  }, [ref]);
};

export default useSwipe;
